import { HeadingPages } from '../../../components/HeadingPages'
import { ResetarCompreGanheForm } from './components/ResetarCompreGanheForm'
import { useResetarCompreGanhe } from './hooks/useResetarCompreGanhe'

export function ResetarCompreGanhe() {
  return <ResetarCompreGanheContent />
}

function ResetarCompreGanheContent() {
  const { register, onSubmit, errors, isLoading } = useResetarCompreGanhe()

  return (
    <div>
      <HeadingPages name="Resetar Compre Ganhe" />
      <ResetarCompreGanheForm onSubmit={onSubmit} isLoading={isLoading} register={register} errors={errors} />
    </div>
  )
}
